import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2bc7778e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc7778e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bc7778e')) {
      api.createRecord('2bc7778e', component.options)
    } else {
      api.reload('2bc7778e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2bc7778e&scoped=true", function () {
      api.rerender('2bc7778e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/applet/setting/mealList/index.vue"
export default component.exports